import { Apps } from "@mui/icons-material";
import { Box, Button, IconButton, Popover, Typography } from "@mui/material";
import { MouseEvent, useState } from "react";
import { IconActivate, IconLink } from "../../../../Assets/Icons";

const appMenu = {
  switchTitle: "Switch to",
  switchLinks: [
    {
      href: import.meta.env.VITE_ACTIVATE_URL,
      linkCopy: "ACTIVATE",
      linkIcon: <IconActivate />,
      testAttribute: "app-menu-activate",
    },
  ],
  learnMoreTitle: "Learn more",
  learnMoreLinks: [
    {
      href: "https://www.nasrecruitment.com",
      linkCopy: "NAS Recruitment Innovation",
      linkIcon: <IconLink />,
      testAttribute: "app-menu-nasrecruitment",
    },
  ],
};

export function AppMenu() {
  const [anchorElApps, setAnchorElApps] = useState<null | HTMLElement>(null);
  const handleOpenAppsMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElApps(event.currentTarget);
  };
  const handleCloseAppsMenu = () => {
    setAnchorElApps(null);
  };
  return (
    <Box sx={{ display: "flex", alignItems: "center", px: { xs: 0, lg: 2 } }}>
      <IconButton
        data-test="app-menu-toggle"
        color="inherit"
        aria-label="Toggle Apps Menu"
        aria-controls="menu-apps"
        aria-haspopup="true"
        onClick={handleOpenAppsMenu}
      >
        <Apps />
      </IconButton>
      <Popover
        aria-label="Apps Menu"
        id="menu-apps"
        keepMounted
        anchorEl={anchorElApps}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElApps)}
        onClose={handleCloseAppsMenu}
        slotProps={{
          paper: {
            sx: {
              px: 2,
              py: 1,
            },
          },
        }}
      >
        <Typography variant="subtitle2" sx={{ pl: 1, color: "text.primary" }}>
          {appMenu.switchTitle}
        </Typography>
        {appMenu.switchLinks.map((link) => (
          <AppMenuButton {...link} key={link.linkCopy} handleClick={handleCloseAppsMenu} />
        ))}
        <Typography variant="subtitle2" sx={{ pl: 1, mt: 1, color: "text.primary" }}>
          {appMenu.learnMoreTitle}
        </Typography>
        {appMenu.learnMoreLinks.map((link) => (
          <AppMenuButton {...link} key={link.linkCopy} handleClick={handleCloseAppsMenu} />
        ))}
      </Popover>
    </Box>
  );
}

function AppMenuButton({
  handleClick,
  linkCopy,
  linkIcon,
  href,
  testAttribute,
}: {
  handleClick: () => void;
  linkCopy: string;
  linkIcon: JSX.Element;
  href?: string;
  testAttribute?: string;
}) {
  return (
    <Button
      data-test={testAttribute}
      component={"a"}
      onClick={handleClick}
      href={href || "#"}
      target="_blank"
      sx={{
        width: 1,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "1ch",
        fontWeight: "normal",
        textDecoration: "none",
        textTransform: "none",
        color: "text.primary",
        p: 1,
      }}
    >
      {linkIcon}
      {linkCopy}
    </Button>
  );
}
